import {
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  createUserWithEmailAndPassword,
  updateProfile,
} from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from './firebase';

// Login
export async function login(email, password) {
  const userCredential = await signInWithEmailAndPassword(
    auth,
    email,
    password
  );
  return userCredential.user;
}

// Logout
export async function logout() {
  await signOut(auth);
}

// Recuperar senha
export async function resetPassword(email) {
  await sendPasswordResetEmail(auth, email);
}

// Cadastro
export async function register({ nome, email, password }) {
  const userCredential = await createUserWithEmailAndPassword(
    auth,
    email,
    password
  );
  await updateProfile(userCredential.user, { displayName: nome });
  await setDoc(doc(db, 'users', userCredential.user.uid), {
    uid: userCredential.user.uid,
    nome,
    email,
    status: 'ativo',
    criadoEm: new Date(),
  });
  return userCredential.user;
}
